export default {
	Interactive: {
		DefaultName: {
			0: 'Sweet Interactive',
			1: 'Cool Interactive',
			2: 'Awesome Interactive',
			3: 'Mind-blowing Interactive',
			4: 'Incredible Interactive',
			5: 'Stunning Interactive',
			6: 'Great Interactive',
			7: 'Superb Interactive',
			8: 'Damn good Interactive',
			9: 'Unbelievable Interactive',
		},
		Status: {
			Show: 'Click to show',
			Hide: 'Click to hide',
		},
	},
	Guard: {
		Disclaimer: 'Use platform\'s dialog window on the right side to take an action.',
		ShareId: {
			Title: 'We need to get know each other better!',
			Message: 'Streamer has added restrictions to this interaction.\n\nSo we need to know your ID on Twitch to check up if everything is correct. Would you mind?',
			Action: 'Share ID',
		},
		Follow: {
			Title: 'Your love is a key to interaction!',
			Message: 'Streamer has marked this interaction to be accessible for followers only.\n\nWould you dare to follow the streamer and take a part in activity?',
			Action: 'Follow',
		},
		Subscribe: {
			Title: 'Your support is a key to interaction!',
			Message: 'Streamer wants this interaction to be accessible for subscribers only.\n\nAnd you may subscribe right now to take a part, would you?',
			Action: 'Subscribe'
		}
	}
};
